<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [ThanksForOrder]
 * Модальное окно / экран "Спасибо за заявку"
 */

import { useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
// import CheckIcon from "@/ui/icons/check.vue";

const classes = useCssModule();

const TIWStore = useTIWStore();

const pathToImages = import.meta.env.VITE_APP_URL;

function onClose() {
    TIWStore.closeWidget();
    useStoreResetter();
}
</script>

<template>
    <Modal>
        <div :class="classes.container">
            <!-- <CheckIcon variant="circled" :class="classes.icon" /> -->
            <img
                :src="`${pathToImages}/img/success.svg`"
                alt="success icon"
                width="60px"
                height="60px"
                :class="classes.icon"
            />
            <p :class="classes.info">
                {{ useTranslate("tiw__thanksForOrder__text") }}
            </p>
            <Button type="button" :class="classes.btnClose" @click="onClose">
                <span>{{ useTranslate("tiw__finish") }}</span>
            </Button>
        </div>
    </Modal>
</template>

<style module>
.container {
    background-color: #fff;
    border-radius: 20px;
    text-align: center;

    .icon {
        margin-bottom: 30px;
    }
}
.header {
    font-size: calc(var(--custom-font-size) * 1.429);
    font-weight: 700;
    line-height: 100%;
    margin: 0;
    margin-bottom: 8px;
}

.info {
    font-size: calc(var(--custom-font-size) * 1);
    font-weight: 400;
    line-height: 140%;
    margin: 0;
    margin-bottom: 24px;
}
.btnClose {
    width: 100%;
}
</style>
